export const defaultSection = {
    classId: null,
    sectionName: '',
    level: '',
    description: '',
    capacity: 1,
    comments: '',
    teacherId: null,
    additionalTeacherIds: [],
}
